<template>
  <div v-if="integralBox" class="integral-box isSelected" v-drag>
    <div :style="{ width: width + 'px' }" class="progress-box"></div>
    <img
      class="image"
      :src="require('@/assets/images/integral_icon.png')"
      mode="widthFix"
    />
    <span class="text">+{{ integral }}积分</span>
  </div>
</template>

<script>
import { InsertIntegrals, GetInsertNumber } from "@/api/index/index.js";
export default {
  name: "integralBox",
  props: {
    // width: {
    //   type: Number,
    //   default: 0,
    // },
  },
  data() {
    return {
      width: 0,
      timer: null,
      integral: "",
      integralBox: false,
    };
  },
  computed: {},
  mounted() {},
  watch: {
    $route(to, from) {},
  },
  methods: {
    // 判断是否可以增加积分
    isAddIntegral() {
      clearInterval(this.timer);
      // this.width = 0;
      // this.timer = null;
      GetInsertNumber({
        id: 6,
      }).then((res) => {
        if (res.msg == "继续加") {
          this.integralBox = true;
          this.integral = res.data.quantity;
          this.timeMeter();
        }
      });
    },
    // 计时器
    timeMeter() {
      // 7.5秒走一次，15分钟加 120rpx
      this.timer = setInterval(() => {
        this.width += 1;
        if (this.width == 121) {
          InsertIntegrals({
            id: "6",
          }).then((res) => {
            this.integralBox = false;
            this.width = 0;
            clearInterval(this.timer);
            this.timer = null;
            if (res.data == true) {
              this.$message.success("添加积分成功");
              this.isAddIntegral();
            } else {
              this.$message.success("今天已经领完了，明天再试试吧！");
            }
          });
        }
      }, 7500);
    },
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>

<style scoped lang="scss">
.integral-box {
  position: absolute;
  top: 110px;
  width: 120px;
  height: 22px;
  border-radius: 11px;
  background-color: #e2e2e2;
  box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.2);
}

.image {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 22px;
}

.integral-box .text {
  position: absolute;
  top: 0;
  left: 30px;
  font-size: 8px;
  line-height: 22px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #777777;
  z-index: 12;
}

.progress-box {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 6;
  width: 22px;
  height: 22px;
  border-radius: 11px;
  background-color: #f7e3bf;
}
.isSelected {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
